import { useState } from 'react';
import { config } from '../config';

export function SignIn() {
  const [isLoading, setIsLoading] = useState(false);

  const handleSignIn = () => {
    setIsLoading(true);
    // Redirect to GitHub OAuth flow (Story 196)
    window.location.href = `${config.apiUrl}/auth/login`;
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--bg-base)',
      }}
    >
      <div
        style={{
          maxWidth: '400px',
          width: '100%',
          padding: '2rem',
          backgroundColor: 'var(--bg-subtle)',
          border: '1px solid var(--border-light)',
          borderRadius: '8px',
          textAlign: 'center',
        }}
      >
        <img
          src="/ceetrix-green.png"
          alt="Ceetrix"
          style={{
            width: '120px',
            height: 'auto',
            marginBottom: '2rem',
          }}
        />
        <h1
          style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            marginBottom: '0.5rem',
            color: 'var(--text-primary)',
          }}
        >
          Welcome to Ceetrix
        </h1>
        <p
          style={{
            marginBottom: '2rem',
            color: 'var(--text-secondary)',
          }}
        >
          Sign in with your GitHub account to manage your backlogs
        </p>
        <button
          onClick={handleSignIn}
          disabled={isLoading}
          style={{
            width: '100%',
            padding: '0.75rem 1.5rem',
            backgroundColor: isLoading ? 'var(--interactive-hover)' : 'var(--interactive)',
            color: 'var(--text-on-brand)',
            border: 'none',
            borderRadius: '6px',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: isLoading ? 'wait' : 'pointer',
            transition: 'background-color 0.15s',
            opacity: isLoading ? 0.8 : 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
          }}
          onMouseEnter={(e) => {
            if (!isLoading) {
              e.currentTarget.style.backgroundColor = 'var(--interactive-hover)';
            }
          }}
          onMouseLeave={(e) => {
            if (!isLoading) {
              e.currentTarget.style.backgroundColor = 'var(--interactive)';
            }
          }}
        >
          {isLoading && (
            <span
              style={{
                width: '16px',
                height: '16px',
                border: '2px solid transparent',
                borderTopColor: 'currentColor',
                borderRadius: '50%',
                animation: 'spin 0.8s linear infinite',
              }}
            />
          )}
          {isLoading ? 'Signing in...' : 'Sign in with GitHub'}
        </button>
        {isLoading && (
          <style>{`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}</style>
        )}
      </div>
    </div>
  );
}
